import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntegrationGithub = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M27 0C12.0825 0 0 12.3881 0 27.6829C0 39.9326 7.72875 50.2791 18.4612 53.9471C19.8112 54.1893 20.3175 53.3589 20.3175 52.6322C20.3175 51.9747 20.2838 49.7947 20.2838 47.4762C13.5 48.7566 11.745 45.7806 11.205 44.2235C10.9012 43.4276 9.585 40.9707 8.4375 40.3133C7.4925 39.7942 6.1425 38.5139 8.40375 38.4793C10.53 38.4447 12.0488 40.4863 12.555 41.3168C14.985 45.5038 18.8663 44.3273 20.4188 43.6006C20.655 41.8012 21.3637 40.5901 22.14 39.898C16.1325 39.206 9.855 36.8183 9.855 26.2296C9.855 23.2191 10.9012 20.7276 12.6225 18.7898C12.3525 18.0977 11.4075 15.2602 12.8925 11.4538C12.8925 11.4538 15.1538 10.7271 20.3175 14.2913C22.4775 13.6684 24.7725 13.357 27.0675 13.357C29.3625 13.357 31.6575 13.6684 33.8175 14.2913C38.9813 10.6925 41.2425 11.4538 41.2425 11.4538C42.7275 15.2602 41.7825 18.0977 41.5125 18.7898C43.2338 20.7276 44.28 23.1845 44.28 26.2296C44.28 36.8529 37.9688 39.206 31.9613 39.898C32.94 40.7631 33.7838 42.4241 33.7838 45.0194C33.7838 48.722 33.75 51.6979 33.75 52.6322C33.75 53.3589 34.2562 54.2239 35.6063 53.9471C46.2712 50.2791 54 39.898 54 27.6829C54 12.3881 41.9175 0 27 0Z",
		fill: "#1B1F23"
	})]
});
const ForwardRef = forwardRef(SvgIntegrationGithub);
export { ForwardRef as ReactComponent };
